<template>
  <div
    v-if="emptyMessage"
    :class="[$style.container, {
      // need to add height to container to keep from seeing scrollbar in modal
      [$style.modalContainer]: inModal
    }]"
  >
    <MarkdownBlock
      :class="$style.message"
      data-test-id="ItemTableEmptyMessage__emptyMessage"
      :mdTemplate="emptyMessage"
    />
  </div>
  <div
    v-else
    :class="$style.container"
  >
    <p :class="$style.message">
      No {{ systemOS }}{{ selectionItemText.plural }} have been added to your organization.
    </p>
    <p
      v-if="route"
      :class="$style.message"
    >
      To add {{ systemOS }}{{ selectionItemText.plural }}, go to
      <a
        :class="$style.link"
        :href="route"
      >
        {{ linkText ? linkText : selectionItemText.plural }}
      </a>
      and click the green plus in the upper left of your screen.
    </p>
  </div>
</template>

<script>
import { MarkdownBlock } from '@jumpcloud/ui-components';
import Constants from 'client/util/Constants';

export default {
  name: 'ItemTableEmptyMessage',

  components: {
    MarkdownBlock,
  },

  props: {
    emptyMessage: {
      default: '',
      type: String,
    },
    inModal: {
      default: false,
      type: Boolean,
    },
    linkText: {
      default: '',
      type: String,
    },
    parentOS: {
      default: '',
      type: String,
    },
    route: {
      default: '#',
      required: true,
      type: String,
    },
    selectionItemText: {
      default: () => ({ plural: 'items', singular: 'item' }),
      type: Object,
      validator: value => !!(value && value.plural && value.singular),
    },
  },

  computed: {
    systemOS() {
      if (this.selectionItemText.plural === 'Systems' && Constants[this.parentOS]) {
        return `${Constants[this.parentOS]} `;
      }
      return '';
    },
  },
};
</script>

<style scoped module>
@value (jcGreen) from '~css/colors.css';

.container {
  padding-top: 35px;
}

.modalContainer {
  height: 100%;
}

.message {
  color: neutralDark;
  font-size: 16px;
  font-weight: 400;
  margin: 5px 0 8px 5px;
  padding: 8px 4px;
  text-align: center;
}

.link {
  text-transform: capitalize;
}
</style>
